import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { MarketdateComment } from './marketdate-comment.model';
import { MarketdateCommentPopupService } from './marketdate-comment-popup.service';
import { MarketdateCommentService } from './marketdate-comment.service';
import { Marketdate, MarketdateService } from '../marketdate';
import { User, UserService } from '../../shared';

@Component({
    selector: 'jhi-marketdate-comment-dialog',
    templateUrl: './marketdate-comment-dialog.component.html'
})
export class MarketdateCommentDialogComponent implements OnInit {

    marketdateComment: MarketdateComment;
    authorities: any[];
    isSaving: boolean;

    marketdates: Marketdate[];

    users: User[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdateCommentService: MarketdateCommentService,
        private marketdateService: MarketdateService,
        private userService: UserService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateComment', 'commentType']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(
            (res: Response) => { this.marketdates = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdateComment.id !== undefined) {
            this.marketdateCommentService.update(this.marketdateComment)
                .subscribe((res: MarketdateComment) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateCommentService.create(this.marketdateComment)
                .subscribe((res: MarketdateComment) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: MarketdateComment) {
        this.eventManager.broadcast({ name: 'marketdateCommentListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdateById(index: number, item: Marketdate) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-comment-popup',
    template: ''
})
export class MarketdateCommentPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateCommentPopupService: MarketdateCommentPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdateCommentPopupService
                    .open(MarketdateCommentDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdateCommentPopupService
                    .open(MarketdateCommentDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-comment/marketdate-comment-dialog.component.ts